import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'


export interface IClusterItem {
  date: string
  typeId: string
}

interface IClusterState {
  items: IClusterItem[]
}

const initialState: IClusterState = {
  items: [],
}



@Injectable({ providedIn: 'root' })
export class ClusterState {
  private _ClusterState = new BehaviorSubject(initialState)
  castClusterState = this._ClusterState.asObservable()
  
  constructor() {}

  get ClusterState() {
    return this._ClusterState.getValue()
  }

  setClusterState(newClusterState: IClusterState) {
    this._ClusterState.next(newClusterState)
  }

  get ClusterState$() {
    return this._ClusterState.asObservable()
  }

  forceCallState() {
    const currentState: IClusterState = {
      items: [...this.ClusterState.items]
    }
    this._ClusterState.next(currentState);
  }
  
  // TODO do not remove this code
  // checkClusterState(newClusterItem: IClusterItem) {
  //   let check = this.ClusterState.items.find(
  //     (item) => item.id === newClusterItem.id && item.action === newClusterItem.action,
  //   )

  //   if (check == undefined) {
  //     this.add(newClusterItem)
  //   } else {
  //     // this.removeClusterItem(newClusterItem)
  //     
  //   }
  // }
  // TODO do not remove this code

  checkClusterState(newClusterItem: IClusterItem) {
    const currentState = this.ClusterState;
    let oldItem = currentState.items.find(
      (item) => item.typeId === newClusterItem.typeId && item.date === newClusterItem.date,
    )

    if(oldItem == undefined){
      this.add(newClusterItem)
    }
  }

  resetState(){
    const newClusterState = {
      items: [],
    } as IClusterState
    this.setClusterState(newClusterState)
  }

  resetStateType(typeToRemove: string){
    const newClusterState = {
      ...this.ClusterState,
      items: this.ClusterState.items.filter(item => item.typeId !== typeToRemove)
    }
    this.setClusterState(newClusterState)
  }

  protected add(newClusterItem: IClusterItem) {
    const currentState = this.ClusterState;
    const newClusterState = {
      ...currentState,
      items: [...currentState.items, newClusterItem],
    } as IClusterState
    this.setClusterState(newClusterState)
  }

  protected removeClusterItem(ClusterItem: IClusterItem) {
    const currentState = this.ClusterState;
    const newItems = currentState.items.filter(
      (item) => !(item.date === ClusterItem.date && item.typeId === ClusterItem.typeId)
    );

    const newClusterState = {
      ...currentState,
      items: newItems,
    } as IClusterState

    this.setClusterState(newClusterState)
  }
}
